import {
  useStyle 
} from "@/classify"
import {
  useImage 
} from "@/hooks/Image/useImage"
import {
  DEFAULT_WIDTH_TO_HEIGHT_RATIO 
} from "@/util/imageUtils"
import defaultClasses from "./image.module.css"
import PlaceholderImage from "./placeholderImage"
import ResourceImage from "./resourceImage"
import SimpleImage from "./simpleImage"

const Image = (props) => {
 
  const {
    alt,
    classes: propsClasses,
    displayPlaceholder = true,
    height,
    onError,
    onLoad,
    placeholder,
    resource,
    src,
    type,
    width,
    widths,
    ratio = DEFAULT_WIDTH_TO_HEIGHT_RATIO,
    ...rest
  } = props

  const talonProps = useImage({
    onError,
    onLoad,
    width,
    widths,
    height,
    ratio,
  })

  const {
    handleError,
    handleImageLoad,
    hasError,
    isLoaded,
    resourceWidth: talonResourceWidth,
    resourceHeight: talonResourceHeight,
  } = talonProps

  const classes = useStyle(defaultClasses, propsClasses)
  const containerClass = `${classes.root} ${classes.container}`
  const isLoadedClass = isLoaded ? classes.loaded : classes.notLoaded
  const imageClass = `${classes.image} ${isLoadedClass}`

  // If we have a src, use it directly. If not, assume this is a resource image.
  const actualImage = src ? (
    <SimpleImage
      alt={alt}
      className={imageClass}
      handleError={handleError}
      handleLoad={handleImageLoad}
      height={talonResourceHeight}
      src={src}
      width={width}
      {...rest}
    />
  ) : (
    <ResourceImage
      alt={alt}
      className={imageClass}
      handleError={handleError}
      handleLoad={handleImageLoad}
      height={talonResourceHeight}
      resource={resource}
      type={type}
      width={talonResourceWidth}
      widths={widths}
      ratio={ratio}
      {...rest}
    />
  )

  return (
    <div className={containerClass}>
      <PlaceholderImage
        alt={alt}
        classes={classes}
        displayPlaceholder={displayPlaceholder}
        height={height}
        imageHasError={hasError}
        imageIsLoaded={isLoaded}
        width={talonResourceWidth}
        src={placeholder}
        {...rest}
      />
      {actualImage}
    </div>
  )
}

export default Image
